import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import './registerServiceWorker'

import routerobj from './router';
import store from './store';
import globals from './plugins/globals';
import freshworks from './plugins/freshworks';
import tokenUtils from './plugins/tokenUtils';
import axioss from 'axios';
import VueAxios from 'vue-axios';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import '@/views';
import './styles/index.scss';
import { loadTheme } from './styles/themes';

// import test  from './modules/pbc/store';
//   console.log(test);

const requestedTheme = (process.env.VUE_APP_THEME || 'default').toLowerCase();
const normalizedTheme = requestedTheme.replace(/[^a-z0-9]/g, '');
loadTheme(normalizedTheme);

const envFontScale = parseFloat(process.env.VUE_APP_FONT_SCALE || '');
if (!Number.isNaN(envFontScale) && envFontScale > 0 && typeof document !== 'undefined') {
  document.documentElement.style.setProperty('--font-scale', envFontScale);
}

const API_URL = process.env.VUE_APP_API_URL;

const getInitialClientId = (clients = [], currentRoute = {}, persistedClientId = '') => {
  const clientList = Array.isArray(clients) ? clients : [];
  const routeClientId = currentRoute?.query?.cid || '';

  if (routeClientId && clientList.some(client => client?._id === routeClientId)) {
    return routeClientId;
  }

  if (persistedClientId && clientList.some(client => client?._id === persistedClientId)) {
    return persistedClientId;
  }

  return clientList[0]?._id || '';
};

Vue.config.productionTip = false

// Configure axios & its middlewares
var axios = axioss.create({
  baseURL: API_URL,
  withCredentials: true
});
// Add a request interceptor
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  config.data = config.data || {};
  if(!config.data.client) config.data.client = store.state.client || "";
    if (config.method === 'get') {
    config.headers = config.headers || {};
    config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
    config.headers['Pragma'] = 'no-cache';
    config.headers['If-None-Match'] = '';
  }
  return config;
}, function (error) {
  console.log(error);
  return Promise.reject(error);
});

// Add a response interceptor
const { default: constants } = require('./plugins/constants');
const { SESSION_EXPIRED_CODES } = constants.AUTH;

let isRedirectingToLogin = false;

function handleSessionExpired() {
  if (isRedirectingToLogin) return;
  isRedirectingToLogin = true;
  // Persist a flag so the login screen can show a "session expired" message after reload
  try { sessionStorage.setItem('session_expired', '1'); } catch (_) { /* storage unavailable */ }
  // Full page reload clears all in-memory Vuex state and re-runs bootstrap,
  // ensuring a clean slate identical to a fresh page load.
  window.location.reload();
}

axios.interceptors.response.use(function (response) {
  try {
    let code = response?.data?.code;
    if (SESSION_EXPIRED_CODES.includes(code)) {
      handleSessionExpired();
    }
    return response;
  } catch (err) {
    console.error('Response interceptor error:', err);
    return response;
  }
}, function (error) {
  // Handle session expiry even if backend returns proper HTTP 401/403
  // Only treat it as session expiry when the response body contains the session-expired code
  // to avoid logging out users who simply lack module permissions
  let code = error?.response?.data?.code;
  if (SESSION_EXPIRED_CODES.includes(code)) {
    handleSessionExpired();
  }
  // Overwrite axios's generic message with the backend's actual error message
  // so all catch blocks using err.message get the meaningful API error
  const serverErrorMessages = error?.response?.data?.message;
  if (serverErrorMessages) error.message = serverErrorMessages;
  console.error('Axios response error:', error?.response?.status || 'Unknown error', error?.message);
  return Promise.reject(error);
});

// Setup other middlewares
Vue.use(VueAxios, axios);
Vue.use(PerfectScrollbar);

// Add tokenUtils to Vue prototype
Vue.prototype.$tokenUtils = tokenUtils;


let router = routerobj.router;
axios.post("/v2/profile/getdetails").then(dt => {
  if(dt.data.status === "success"){
    let rdata = (dt.data.data || [])[0] || {};
    const clientdata = Array.isArray(rdata.clients) ? rdata.clients : [];
    const selectedClientId = getInitialClientId(
      clientdata,
      router.currentRoute,
      typeof localStorage !== 'undefined' ? localStorage.getItem('Entity') : ''
    );

    store.commit("setClientList", clientdata);
    store.commit("setClientDetails", clientdata.find(client => client?._id === selectedClientId) || {});
    if (selectedClientId) {
      store.commit("setClient", selectedClientId);
    }
    return store.commit("setSubscription", rdata.subscription || {});            
  }else{
    console.log("Error fetching subscription list");
  }
}).catch(err => {
  console.log(err);
}).then(() => {
  return addCustomModules();
}).finally(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app');
  Vue.use(globals);
  Vue.use(freshworks);
});


// To register the custom modules
async function addCustomModules(){
  // module name, subscription product name, cart group
  await registerCustomeModule("admin", ["admin"], "others");
  await registerCustomeModule("home", ["home"], "ucp");
  await registerCustomeModule("pbc", ["pbc"], "risk");
  await registerCustomeModule("varianceanalysis", ["varianceanalysis"], "accounting");
  await registerCustomeModule("financialclose", ["financialclose"], "accounting");
  await registerCustomeModule("tds", ["tds_ar","tds_ap","tds_monthly"], "compliance");
  await registerCustomeModule("earnout", ["earnout"], "transaction");
  await registerCustomeModule("bot", ["bot"], "others");
  await registerCustomeModule("ia", ["ia"], "risk");
  await registerCustomeModule("helpdesk", ["helpdesk"], "others");
  await registerCustomeModule("flux", ["flux"], "others");
  await registerCustomeModule("chatbot", ["chatbot"], "others");
  await registerCustomeModule("manuals", [], "others");
}

async function registerCustomeModule(name, subscription, solution){
  const {default: modname} = await import('./modules/'+name+'/store');
  store.registerModule("m_"+name, modname);
  const {default: routes} = await import('./modules/'+name+'/route');
  router.onReady(() => {
    let routelist = registerCustomRouter(routes, name, subscription, solution)
    for (const i of routelist) {
      router.addRoute(i);
    }
  })
  try{
    const {default: config} = await import('./modules/'+name+'/config');
    config.init();
  }catch(err){return}
}

function registerCustomRouter(routes, moduleName, subscription, solution){
  let rt = [];
  for (const el of routes) {
    let nrt = {meta: {}};
    if(el.path) nrt = routerobj.getRouteData(moduleName, solution, el.path, el.component, el.meta, el.function, el.noaccess);
    if(el.children) nrt.children = registerCustomRouter(el.children, moduleName, subscription, solution);
    nrt.meta["subscription"] = subscription;
    nrt.meta["solution"] = solution;
    nrt.meta["modulename"] = moduleName;
    rt.push(nrt);
  }
  return rt;
}


